<div class="grid-container">
  <form [formGroup]="form">
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <div class="grid-x">
          <div class="cell small-3 medium-3 large-3 bold padding-right">
            Well API:
          </div>
          <div class="cell small-3 medium-3 large-3">
            <input type="text" formControlName="apiNumber" />
          </div>
          <div class="cell small-6 medium-6 large-6" [ngClass]="{ 'text-align-center': !disableSearch }">
            @if (disableSearch == false) {
              <span class="padding-left padding-right">
                <button (click)="searchWells()" class="button" [disabled]="disableSearch  || searchActive">Search</button>
              </span>
              <span class="padding-left padding-right">
                <button (click)="reset()" class="button" [disabled]="disableSearch || searchActive">Reset</button>
              </span>
              <span class="padding-left padding-right">
                <button (click)="export()" class="button" [disabled]="results == null || results.length === 0">Export</button>
              </span>
            } @else {
              <span class="padding-left">
                <text-loader [run]="disableSearch" [text]="'Populating options '" [tickType]="'.'" [interval]="1000" [cycleLimit]="10"></text-loader>
              </span>
            }
          </div>
          <div class="cell small-12 medium-12 large-12 red italic">
            @if (invalidAPI && apiNumber?.length > 0) {
              <small>API # must be 14 characters long.</small>
            }
          </div>
        </div>
      </div>
      <div class="cell large-12 medium-12 small-12">
        <div class="grid-x">
          <div class="cell small-3 medium-3 large-3 bold padding-right">
            RICS Organization ID:
          </div>
          <div class="cell small-3 medium-3 large-3">
            <input type="text" formControlName="RICSOrganizationId" />
          </div>
          <div class="cell small-3 medium-3 large-3 bold padding-right padding-left">
            RBDMS Owner #:
          </div>
          <div class="cell small-3 medium-3 large-3">
            <input type="text" formControlName="RBDMSOwnerNumber" />
          </div>
          <div class="cell small-12 medium-12 large-12 red italic">
            @if (invalidRICSNumber && RICSOrganizationId?.length > 0) {
              <small>RICS Organization ID must start with 'ON' and be 15 characters long.</small>
            }
          </div>
        </div>
      </div>
      <div class="cell large-12 medium-12 small-12">
        <div class="grid-x">
          <div class="cell small-3 medium-3 large-3 bold padding-right">
            County:
          </div>
          <div class="cell small-3 medium-3 large-3">
            <select id="county" formControlName="county">
              @for (c of countyObservable | async; track c) {
                <option [ngValue]="c">{{c}}</option>
              }
            </select>
          </div>
          <div class="cell small-3 medium-3 large-3 bold padding-left">
            Township:
          </div>
          <div class="cell small-3 medium-3 large-3">
            <select id="township" formControlName="township">
              @for (t of townshipObservable | async; track t) {
                <option [ngValue]="t">{{t}}</option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="cell small-12 medium-12 large-12 red italic">
        @if (invalid) {
          <small>One of API #, RICS Organization ID, RBDMS Owner Number, County, or Township must be provided to run the search.</small>
        }
        <text-loader [run]="searchActive" [text]="'Searching'" [tickType]="'.'" [interval]="1000" [cycleLimit]="20"></text-loader>
        @if (!invalid && !searchActive) {
          <span>&nbsp;</span>
        }
      </div>
    </div>
  </form>
  <div class="grid-x">
    <div class="large-12 medium-12 small-12">
      <app-organization-wells-grid [data]="results" [gridAriaLabel]="widgetTitle"></app-organization-wells-grid>
    </div>
  </div>
</div>

